import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import productsBannerImageMobile from 'src/modules/products/assets/products-banner-mobile.jpg';
import { Media } from 'vendor/mods/media-breakpoints-fresnel/components/Media';

const ImageContainer = styled.div`
  z-index: 1;
  justify-self: center;
  height: 360px;
  position: relative;
`;

const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center 18px;
`;

const Gradient = styled.div`
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 104px;
  left: 0px;
  top: 0;
  background: linear-gradient(
    180deg,
    #cd0338,
    rgba(205, 3, 56, 0.39) 46.35%,
    rgba(205, 3, 56, 0) 100%
  );
`;

export const ProductsBannerImageMobile = () => {
  return (
    <Media lessThan="desktop">
      <Gradient />
      <ImageContainer>
        <StyledImage
          src={productsBannerImageMobile}
          layout="fill"
          sizes="100vw"
        />
      </ImageContainer>
    </Media>
  );
};
